{
  "name": "loan-renewal-fe",
  "version": "4.6.1",
  "scripts": {
    "install": "cp ./package.json ./src/assets",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --code-coverage",
    "watch": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.1",
    "@angular/common": "^21.0.1",
    "@angular/compiler": "^21.0.1",
    "@angular/core": "^21.0.1",
    "@angular/forms": "^21.0.1",
    "@angular/material": "^21.0.0",
    "@angular/platform-browser": "^21.0.1",
    "@angular/platform-browser-dynamic": "^21.0.1",
    "@angular/router": "^21.0.1",
    "rxjs": "~7.5.0",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.0.1",
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.0.0",
    "@angular/cdk": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.1",
    "@angular/material-luxon-adapter": "^21.0.0",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.5.1",
    "@sparbanken-syd/loan-renewal-be": "^5.10.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/renewal-tool": "^4.2.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.0.0",
    "@types/jasmine": "^4.0.3",
    "@types/luxon": "^3.3.2",
    "@types/node": "^22",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "@typescript-eslint/utils": "^8.33.1",
    "angular-eslint": "^21.0.1",
    "eslint": "^10.2.0",
    "jasmine-core": "^5.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "karma-spec-reporter": "^0.0.36",
    "luxon": "^3.4.2",
    "postcss": "^8.5.9",
    "postcss-scss": "^4.0.9",
    "puppeteer": "^24.36.0",
    "stylelint": "^17.6.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.33.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz"
  }
}
